export const checkLinkActived = (match, location) => {
  if (!match) {
    return false
  }

  return match.url === location.pathname
}

export const checkTurnOnBatchMultiple = ({ configFTL = {}, customerID = 0, companyID = 0 }) => {
  const { settings = {} } = configFTL
  if (!settings || Object.keys(settings).length === 0) return false

  const { beta_company_batch_multiple = '', beta_customer_batch_multiple = '' } = settings

  let permission = false
  const userID = companyID || customerID
  const vipIds = companyID ? beta_company_batch_multiple : beta_customer_batch_multiple

  if (vipIds) {
    const string = vipIds.replace(/\s/g, '')
    const splitVipIds = string.split(',')
    permission = splitVipIds.includes(userID.toString())
  } else {
    permission = true
  }

  return permission
}

export const checkEnabledWallet = ({ configFTL = {}, type = '' }) => {
  const { settings = {} } = configFTL
  if (!settings || Object.keys(settings).length === 0) return false

  const { enabled_ewallet = [] } = settings
  return enabled_ewallet.includes(type.toString())
}

export const checkEnabledEmployess = (currentEmploy = {}) => {
  if (!currentEmploy || Object.keys(currentEmploy).length === 0) return false

  // { employee: 0, admin: 1, owner: 2 }
  return ['owner', 'admin'].includes(currentEmploy.assigned_role)
}

export const checkEnabledAPIDashboard = (currentEmploy = {}) => {
  const company = currentEmploy?.company
  if (!company || Object.keys(company).length === 0) return false

  return company.status === 'approved' && company.show_api_dashboard
}
